import nextTick from '../lib/next-tick.mjs';
import contentLoaded from '../lib/content-loaded.mjs';

let $search;
let $dialog;
let $openButton;
let $searchField;

function __initialize() {
  $search = document.querySelector('.js-g-search');
  $dialog = $search.querySelector($search.dataset.dialog);
  $openButton = $search.querySelector($search.dataset.openButton);
  $searchField = $search.querySelector($search.dataset.searchField);

  addEventListeners();
}

function handleKeyPressSearchField(event) {
  if (event.key !== 'Escape') { return; }

  closeDialog();
}

function openDialog() {
  $dialog.addEventListener('keydown', handleKeyPressSearchField);
  $dialog.classList.add('is-open');
  $searchField.focus();
}

function closeDialog() {
  $openButton.focus();
  $dialog.classList.remove('is-open');
  $dialog.removeEventListener('keydown', handleKeyPressSearchField);
}

function handleClickOpenButton(event) {
  if ($dialog.classList.contains('is-open')) {
    closeDialog();
  } else {
    openDialog();
  }
}

function addEventListeners() {
  $openButton.addEventListener('click', handleClickOpenButton, false);
}

contentLoaded(__initialize);
